import http from '../clients/Axios'

export default class SaldoAwalHutangService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          filters_param =
            filters_param + '&filter[' + el + ']=' + filters[el].value
        }
      })
    }

    const res = await http.get(
      `/account/saldo/hutang/paginate?page[number]=${pageNumber}&page[size]=${pageSize}&sort=${sort}${filters_param}`
    )

    return res.data
  }

  async get(param) {
    param = param ? param : ''
    return await http.get(`/account/saldo/hutang${param}`)
  }

  async add(form) {
    return await http.post('/account/saldo/hutang', form)
  }

  async update(form, id) {
    return await http.post(`/account/saldo/hutang/${id}`, form)
  }

  async delete(id) {
    return await http.delete(`/account/saldo/hutang/${id}`)
  }

  async exportPdf() {
    return http({
      url: `/account/saldo/hutang/print`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async exportExcel() {
    const unixTime = Math.floor(Date.now() / 1000)
    return http({
      url: `/account/saldo/hutang/export?t=${unixTime}`,
      method: 'GET',
      responseType: 'blob',
    })
  }

  async import(value) {
    let formData = new FormData()
    formData.append('import_file', value)

    return await http.post(`/account/saldo/hutang/import`, formData)
  }

  async templateImport() {
    return http({
      url: `/account/saldo/hutang/import/download`,
      method: 'GET',
      responseType: 'blob',
    })
  }
}
